import { render } from "./createRouteForm.vue?vue&type=template&id=12f72c2a&scoped=true"
import script from "./createRouteForm.vue?vue&type=script&lang=js"
export * from "./createRouteForm.vue?vue&type=script&lang=js"

import "./createRouteForm.vue?vue&type=style&index=0&id=12f72c2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f72c2a"]])

export default __exports__